// 文件/文件夹类型定义
export interface FileNode {
  id: string;
  name: string;
  type: 'file' | 'folder';
  parentFolderId?: string;
  children?: FileNode[];
  createdAt?: string;
  updatedAt?: string;
  // 用于前端显示的路径
  path?: string;
}

// 生成基于字符串的稳定 id（用于后端未提供 id 的场景）
export function stableIdFromString(input: string): string {
  let hash = 5381;
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 33) ^ input.charCodeAt(i);
  }
  // >>>0 to convert to unsigned
  return 's-' + (hash >>> 0).toString(16);
}

// 处理 API 返回的文件树结构
export function buildFileTree(files: any[]): FileNode[] {
  if (!files || files.length === 0) {
    return [];
  }

  // 排序：文件夹在前，文件在后，同类型按名称排序
  const sortNodes = (nodes: FileNode[]): FileNode[] => {
    return nodes.sort((a, b) => {
      if (a.type !== b.type) {
        return a.type === 'folder' ? -1 : 1;
      }
      return a.name.localeCompare(b.name);
    });
  };

  // 递归处理树节点
  // 如果后端返回的节点缺少 `id` 字段，前端需要为其生成稳定的 id
  const processNode = (node: any, parentPath = ''): FileNode => {
    const nodePath = parentPath ? `${parentPath}/${node.name}` : node.name;
    const nodeId = node.id || stableIdFromString(nodePath);

    const processed: FileNode = {
      id: nodeId,
      name: node.name,
      type: node.type,
      parentFolderId: node.parentFolderId ?? null,
      createdAt: node.createdAt,
      updatedAt: node.updatedAt,
      path: nodePath,
    };

    if (node.children && node.children.length > 0) {
      processed.children = sortNodes(
        node.children.map((child: any) => processNode(child, nodePath))
      );
    }

    return processed;
  };

  return sortNodes(files.map(file => processNode(file)));
}
